const MAX_COLUMNS = 12;
const MIN_COL_SPAN = 1;
const MAX_CELLS = 6;
const MAX_VERTICAL_MARGIN = 250;
const LAYOUT_DEFAULTS = {
  backgroundColor: null,
  backgroundImage: null,
  borderColor: null,
  borderWidth: 0,
  borderRadius: 0,
  backdropColor: null,
  backdropImage: null,
  backdropPaddingTop: 0,
  backdropPaddingBottom: 0,
  gap: 20,
  cellPadding: [18, 0, 18, 0],
  cellVerticalAlignment: "TOP",
  responsivenessBehaviour: "STACK",
  responsivenessBreakpoint: 440,
  designTarget: "LAYOUT",
  banner: null
};
const normalizePadding = (padding, defaults) => {
  if (!padding || padding.length === 0) {
    return defaults;
  }
  if (padding.length === 1) {
    return [padding[0], padding[0], padding[0], padding[0]];
  }
  if (padding.length === 2) {
    return [padding[0], padding[1], padding[0], padding[1]];
  }
  if (padding.length === 3) {
    return [padding[0], padding[1], padding[2], padding[1]];
  }
  return padding;
};
export {
  LAYOUT_DEFAULTS,
  MAX_CELLS,
  MAX_COLUMNS,
  MAX_VERTICAL_MARGIN,
  MIN_COL_SPAN,
  normalizePadding
};
//# sourceMappingURL=shared-with-viewer.js.map
